import { render } from "./zyjs.vue?vue&type=template&id=22cc0006&scoped=true&ts=true"
import script from "./zyjs.vue?vue&type=script&lang=ts"
export * from "./zyjs.vue?vue&type=script&lang=ts"

import "./zyjs.vue?vue&type=style&index=0&id=22cc0006&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cc0006"]])

export default __exports__